import type { ComponentProps } from 'react';
import { ChevronDownIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Tanlov maydoni — Radix `Select` EMAS, brauzerning o'z `<select>` i, shadcn ko'rinishida.
 *
 * Bu ongli tanlov. Admin paneldagi filtrlar ro'yxati `receipts.status` kabi server enum'laridan
 * to'g'ridan-to'g'ri chiziladi, forma esa `<form>` submit'i bilan yuboriladi — ya'ni bizga
 * portalga chiqadigan, o'z holatini o'zi boshqaradigan menyu emas, oddiy forma nazorati kerak.
 * Yutuq amaliy: klaviatura, mobil OS tanlagichi va avtomatlashtirilgan testlar hech qanday
 * moslashtirishsiz ishlaydi.
 */
function Select({ className, children, ...props }: ComponentProps<'select'>) {
  return (
    <div className="relative">
      <select
        data-slot="select"
        className={cn(
          'border-input dark:bg-input/30 flex h-9 w-full appearance-none rounded-md border bg-transparent py-1 pr-8 pl-3 text-sm shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
          '[&>option]:bg-popover [&>option]:text-popover-foreground',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon
        aria-hidden="true"
        className="text-muted-foreground pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2"
      />
    </div>
  );
}

export { Select };
